import { z } from 'zod';

export interface BulkUserOperationRequestDto {
  userIds: string[];
  operation: BulkUserOperationType;
  data?: BulkUserOperationData;
}

export interface BulkUserOperationData {
  // For app access toggle
  hasAppAccess?: boolean;
  // For team assignments
  teamIds?: number[];
  // TODO: Add other data types as needed
}

export enum BulkUserOperationType {
  DELETE_USERS = 'DELETE_USERS',
  TOGGLE_APP_ACCESS = 'TOGGLE_APP_ACCESS',
  ASSIGN_TEAMS = 'ASSIGN_TEAMS',
  REMOVE_TEAMS = 'REMOVE_TEAMS',
}

// Zod schemas for validation
export const BulkUserOperationRequestSchema = z.object({
  userIds: z.array(z.string()).min(1, 'At least one user ID is required'),
  operation: z.nativeEnum(BulkUserOperationType),
  data: z
    .object({
      hasAppAccess: z.boolean().optional(),
      teamIds: z.array(z.number()).optional(),
    })
    .optional(),
});

export const BulkUserOperationResponseSchema = z.object({
  successCount: z.number(),
  failureCount: z.number(),
  results: z.array(
    z.object({
      userId: z.string(),
      success: z.boolean(),
      message: z.string().optional(),
    })
  ),
  errors: z.array(
    z.object({
      userId: z.string(),
      error: z.string(),
      code: z.string().optional(),
    })
  ),
});

export type BulkUserOperationRequest = z.infer<
  typeof BulkUserOperationRequestSchema
>;
export type BulkUserOperationResponse = z.infer<
  typeof BulkUserOperationResponseSchema
>;
